import { Button } from "@/components/Button";
import { LayoutBody, LayoutHeader } from "@/components/Layout";
import { Spinner } from "@/components/Spinner";
import { ServiceProviderType, ServiceTypeEnum } from "@/types/Building";
import { useEffect } from "react";

export default function BiltContainer({ title }: { title: string }) {
  const isFromNativeApp = localStorage.getItem("mobile") === "true";

  if (!import.meta.env.VITE_BILT_URL) {
    return (
      <div className="flex flex-col h-screen items-center justify-center">
        <h1 className="text-xl font-bold text-red-500">Configuration Error</h1>
        <p className="text-center text-gray-700">
          The application is misconfigured. Please contact support.
        </p>
      </div>
    );
  }

  if (isFromNativeApp) {
    return <BiltWidgetMobile />;
  }

  return <BiltWidget title={title} />;
}

function createLivlyFeCookie() {
  const livlyFeCookie = {
    serviceType: ServiceTypeEnum.Rent,
    serviceProviderType: ServiceProviderType.Bilt,
  };
  document.cookie = `livly.fe=${JSON.stringify(
    livlyFeCookie
  )}; path=/; domain=${import.meta.env.VITE_COOKIE_DOMAIN};`;
}

function BiltWidget({ title }: { title: string }) {
  const onClick = () => {
    createLivlyFeCookie();
    window.open(import.meta.env.VITE_BILT_URL, "_blank");
  };

  return (
    <div className="flex flex-col h-screen">
      <LayoutHeader title={title} />
      <LayoutBody className="flex flex-col items-center justify-center flex-1 space-y-4">
        <p className="text-sm text-gray-700">
          Your content will open in a new tab. If it doesn't, please click the
          button below.
        </p>
        <Button color="secondary" onClick={onClick} data-test="clickpay-button">
          Pay Rent with Bilt
        </Button>
      </LayoutBody>
    </div>
  );
}

function BiltWidgetMobile() {
  useEffect(() => {
    createLivlyFeCookie();
    window.location.replace(import.meta.env.VITE_BILT_URL);
  }, []);

  return (
    <div className="flex flex-col h-screen">
      <LayoutBody className="flex items-center justify-center flex-1">
        <Spinner color="livly" size="xl" />
      </LayoutBody>
    </div>
  );
}
